<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <div class="search-box">
                <el-button class="search-hd" type="primary" icon="el-icon-search" @click="searchKeyword(keyword)"></el-button>
                <div class="search-bd">
                    <search-bar :ajaxSearch="false" v-model="keyword" @enter-key="searchKeyword" @select="searchKeyword"
                                placeholder="请输入模版名称"></search-bar>
                </div>
            </div>
            <filter-panel @params-change="getParams" ref="condition">
                <filter-panel-item v-for="(item, index) in filterConf" :label="item.label" :mode="item.mode"
                                   :name="item.name" :data="item.data" :key="index"
                                   :initValue="item.value"></filter-panel-item>
            </filter-panel>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                        <el-button icon="el-icon-plus" type="primary" @click="$refs.editView.show()">新建邮件模版</el-button>
                    </el-col>
                    <el-col :span="12">
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <el-button @click="remove(idStr, true)" icon="el-icon-my-guanbi color-danger" type="danger"
                                       :plain="true">删除
                            </el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="模版名称"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="150">
                            <template slot-scope="scope">
                                <a href="javascript://" @click="$refs.preview.show(scope.row.id)">{{ scope.row.name }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘阶段"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_PHASE', scope.row.phase)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="邮件标题"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="150">
                            <template slot-scope="scope">
                                {{ scope.row.title }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label='用户类型'
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_USER_ATTRIBUTES', scope.row.userAttributes)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="是否可用"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ ['不可用', '可用'][scope.row.visible] }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="是否私有"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ ['否', '是'][scope.row.isPrivate] }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                min-width="100">
                            <template slot-scope="scope">
                                <el-button type="text" @click="$refs.editView.show(scope.row)">编辑</el-button>
                                <el-button type="text" @click="remove(scope.row.id)"><span
                                        class="color-danger">删除</span></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
        <view-email-tpl ref="preview"></view-email-tpl>
        <edit-email-tpl ref="editView" @reloadList="fetchData"></edit-email-tpl>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import selectMapMixin from 'mixins/selectMapMixin'
    import operationMixin from '../operation/operationMixin'
    import EditEmailTpl from './editEmailTpl'
    import ViewEmailTpl from './viewEmailTpl'

    export default {
        'extends': QueryListExtend,
        'mixins': [selectMapMixin, operationMixin],
        data () {
            return {
                fetchUrl: '/system/mailTemplate/list.api',
                removeUrl: '/system/mailTemplate/delete.api',
                filterConf: [{
                    name: 'phase',
                    filter: 'WB_PHASE',
                    label: '招聘阶段',
                    visible: false,
                    mode: 'single',
                    data: []
                }, {
                    name: 'userAttributes',
                    filter: 'WB_USER_ATTRIBUTES',
                    label: '用户类型',
                    mode: 'single',
                    visible: false,
                    data: []
                }, {
                    name: 'isPrivate',
                    filter: 'WB_PRIVATE',
                    label: '是否私有',
                    mode: 'single',
                    visible: false,
                    data: []
                }, {
                    name: 'visible',
                    filter: 'WB_VISIBLE',
                    label: '是否可用',
                    mode: 'single',
                    visible: false,
                    data: []
                }],
                searchData: {
                    searchWord: null
                }
            }
        },
        methods: {},
        components: {
            EditEmailTpl,
            ViewEmailTpl
        }
    }
</script>
<style type="text/css" lang="scss">

</style>


// WEBPACK FOOTER //
// emailTplList.vue?2d13b197